import {type FC, useCallback} from 'react';
import {runAnalytics} from '../../analytics.js';

type TaggingQuoteClickHandlerProps<P> = {
  taggingLabel?: string;
  fieldName: string;
  onClick?: (...args: any[]) => void;
  value?: any;
  linkValue?: string;
  eventAction: string;
  journeyActionNarrative?: string;
  resourceFileName?: string;
  journeyEvent?: string;
  journeyAction?: string;
  qaQuestion?: string;
  qaAnswer?: string;
} & P;

const withTaggingQuoteClickHandler = <P,>(Component: FC<P>) => {
  const FieldWithTaggingClickHandler: FC<TaggingQuoteClickHandlerProps<P>> = ({
    taggingLabel,
    linkValue,
    onClick,
    value,
    fieldName,
    eventAction,
    journeyActionNarrative,
    resourceFileName,
    journeyEvent,
    journeyAction,
    qaQuestion,
    qaAnswer,
    ...rest
  }: TaggingQuoteClickHandlerProps<P>) => {
    const handleOnClick = useCallback(
      (...args: any) => {
        if (onClick) {
          onClick(...args);
        }

        if (taggingLabel) {
          runAnalytics((LBGAnalytics) => {
            LBGAnalytics.events.send({
              JourneyEvent: journeyEvent,
              EventAction: eventAction,
              EventNarrative: taggingLabel,
              FieldName: taggingLabel,
              LinkValue: linkValue,
              JourneyAction: journeyAction ?? 'undefined',
              JourneyActionNarrative: journeyActionNarrative ?? 'undefined',
              ResourceFileName: resourceFileName,
              QAQuestion: qaQuestion ?? 'undefined',
              QAAnswer: qaAnswer ?? 'undefined',
            });
          });
        }
      },
      [
        onClick,
        taggingLabel,
        linkValue,
        resourceFileName,
        journeyEvent,
        eventAction,
        journeyAction,
        journeyActionNarrative,
        qaQuestion,
        qaAnswer,
      ]
    );

    return <Component {...(rest as P)} value={value} onClick={handleOnClick} />;
  };

  return FieldWithTaggingClickHandler;
};

export default withTaggingQuoteClickHandler;
